export default [
    {
        name: 'domain',
        sortField: 'domain',
        type: 'string',
        callback: 'domain',
        useInFilter: true,
    },
    {
        name: '__slot:url_group',
        sortField: 'url',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'it1',
        sortField: 'it1',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'it3',
        sortField: 'it3',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'it5',
        sortField: 'it5',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'it10',
        sortField: 'it10',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'it50',
        sortField: 'it50',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
        isDefault: true
    },
    {
        name: 'vis',
        sortField: 'vis',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },

]